import Heading from "components/Heading";
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Button, Col, Container, Row, Table, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem, Alert
} from "reactstrap";
import { errorHandler, toLocaleTime } from "utils/Api";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { DELIVERY_ROUTE_STATUS, DELIVERY_ROUTE_STATUS_CODES } from "utils/Constants";
import { deleteDeliveryRoute, getDeliveryRoutes } from "api/DeliveryRouteApi";
import LoadingTBody from "components/LoadingTBody";
import { showAlert } from "utils/Alert";
import DeleteModal from "components/DeleteModal";


const DeliveryRoute = props => {
  let navigate = useNavigate();
  const [deliveryRoutesList, setDeliveryRoutesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [toDeliveryRoute, setToDeliveryRoute] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetchDeliveryRoutes();
  }, [deliveryRoutesList.length]);

  const fetchDeliveryRoutes = () => {
    getDeliveryRoutes().then((boxes) => {
      setDeliveryRoutesList(boxes);
    }).catch((e) => errorHandler(e, "fetch deliveryRoute movements error"))
      .finally(() => {
        setIsLoading(false);
      });
  }

  const renderList = () => {
    return deliveryRoutesList.map((deliveryRoute) => {
      let date = toLocaleTime(deliveryRoute.date);
      return (
        <tr key={deliveryRoute.id}>
          <td>
            {deliveryRoute.secuencia}
          </td>
          <td>
            {deliveryRoute.delivery_man}
          </td>
          <td>
            {date}
          </td>
          <td>
            {DELIVERY_ROUTE_STATUS[deliveryRoute.status]}
          </td>
          <td>
            {rowActions(deliveryRoute)}
          </td>
        </tr>
      );
    });
  }

  const removeDeliveryRoute = (deliveryRoute) => {
    setIsLoading(true);
    deleteDeliveryRoute(deliveryRoute)
      .then(async (r) => {
        showAlert("success", `La Ruta #${deliveryRoute.secuencia} fue eliminado correctamente`);
        toogleModal();
      }).catch(e => {
        errorHandler(e);
        showAlert("danger", `No fue posible eliminar la ruta #${deliveryRoute.secuencia}`);
      })
      .finally(() => fetchDeliveryRoutes());
  }

  const showDeleteConfirm = (deliveryRoute) => {
    if (!deliveryRoute.status || DELIVERY_ROUTE_STATUS_CODES.SCHEDULED === deliveryRoute.status) {
      setToDeliveryRoute(deliveryRoute);
      setIsModalOpen(true);
    } else {
      showAlert("danger", `No es posible eliminar la Ruta #${deliveryRoute.secuencia}, por que esta actualmente en transito o ya fue entregado`);
    }
  }

  const toogleModal = (e) => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setToDeliveryRoute({});
    }
  }

  const rowActions = (deliveryRoute) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/route/edit/${deliveryRoute.id}`) }}>
            Editar Movimiento
          </DropdownItem>
          <DropdownItem onClick={(e) => showDeleteConfirm(deliveryRoute)}>
            Eliminar Movimiento
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  return (
    <>
      <Heading headingLevel="h2" className="pt-4" label="Rutas de Entrega" sticky >
        <Col sm={2}>
          <Button
            className="float-end"
            color="success"
            onClick={(e) => navigate("/admin/route/add")}
          > Crear Ruta</Button>
        </Col>
      </Heading>
      <Container>
        <Row>
          <Col>
            <Table hover>
              <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    Repartidor
                  </th>
                  <th>
                    Fecha Salida
                  </th>
                  <th>
                    Estado
                  </th>
                  <th width="2%"></th>
                </tr>
              </thead>
              <LoadingTBody isLoading={isLoading}>
                {renderList()}
              </LoadingTBody>
            </Table>
            {toDeliveryRoute && toDeliveryRoute.id && (
              <DeleteModal
                title="Eliminar File"
                toogle={toogleModal}
                isOpen={isModalOpen}
                onDelete={() => { removeDeliveryRoute(toDeliveryRoute) }}>
                <Alert color="warning">
                  Los Paquetes agregados a esta ruta van a ser liberados
                </Alert>
                Esta seguro que desea eliminar el ruta #{toDeliveryRoute.secuencia}?
              </DeleteModal>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default DeliveryRoute;
